function DepartingTodayIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={16} cy={16} r={16} fill="#48BB78" />
      <path
        d="M9.052 8.063a.688.688 0 00-.677.687v12.53c0 .245.131.472.344.595l6.875 3.97a.687.687 0 001.031-.594v-3.282h4.125c.38 0 .688-.31.688-.69v-3.514a.687.687 0 10-1.375 0v2.827h-3.438V12.72a.687.687 0 00-.344-.597l-4.65-2.685h8.432v2.827c-.013.93 1.388.93 1.375 0V8.75a.687.687 0 00-.688-.687H9.052zm4.136 8.25a.688.688 0 110 1.376.688.688 0 010-1.377z"
        fill="#fff"
      />
      <path
        d="M23.507 11.922a.685.685 0 00-.695.688v1.718h-3.428a.687.687 0 100 1.375h3.428v1.719a.687.687 0 001.08.564l3.439-2.408a.687.687 0 000-1.127l-3.438-2.406a.681.681 0 00-.386-.123z"
        fill="#fff"
      />
    </svg>
  )
}

export default DepartingTodayIcon
